import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh', display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
          background: 'linear-gradient(to bottom, #faf5ff, #ffffff)',
          padding: '2rem', textAlign: 'center'
        }}>
          <img src="/images/simby-mascote.png" alt="Simby" style={{ width: 80, marginBottom: 16 }} />
          <h2 style={{ color: '#7c3aed', fontFamily: 'sans-serif', marginBottom: 8 }}>
            Ops, algo deu errado
          </h2>
          <p style={{ color: '#6b7280', fontFamily: 'sans-serif', marginBottom: 24 }}>
            Tivemos um problema inesperado. Tente recarregar a página.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: '#7c3aed', color: '#fff', border: 'none',
              borderRadius: 8, padding: '10px 24px', cursor: 'pointer',
              fontFamily: 'sans-serif', fontSize: 14
            }}
          >
            Recarregar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
